<template>
    <div class="wrap">
        <div class="wrap_item">
            <div class="card" v-for="(modelvue, index) in hodimlar" :key="index">
                
                <!-- Rasm konteyneri (Uzun qilindi) -->
                <div class="image-box">
                    <img 
                        :src="getImageUrl(modelvue.image)" 
                        alt="Xodim rasmi" 
                        @error="handleImageError"
                    />
                </div>
                
                <h5 class="user-name">{{ modelvue.user_name }}</h5>
                
                <!-- Reyting -->
                <div class="card_reyting">
                    <div class="icon" :class="{ selected: modelvue.reyting === 1 }" @click="setRating(modelvue, 1)">
                        <span>😡</span>
                    </div>
                    <div class="icon" :class="{ selected: modelvue.reyting === 3 }" @click="setRating(modelvue, 3)">
                        <span>😕</span>
                    </div>
                    <div class="icon" :class="{ selected: modelvue.reyting === 5 }" @click="setRating(modelvue, 5)">
                        <span>😊</span>
                    </div>
                </div>

                <!-- Izoh -->
                <textarea 
                    v-model="modelvue.comment" 
                    class="text_input" 
                    placeholder="Izoh qoldiring..."
                ></textarea>
                
                <button class="btn" @click="sendReyting(modelvue, index)">Yuborish</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    inject: ["BASE_URL"],
    data() {
        return {
            hodimlar: [],
            defaultImage: '/doctor_awatar.jpg' // Standart rasm
        }
    },
    methods: {
        // Rasmni to'g'ri shakllantirish funksiyasi
        getImageUrl(imageName) {
            if (!imageName) return this.defaultImage;
            // Agar BASE_URL oxirida '/' bo'lmasa, uni qo'shamiz
            let baseUrl = this.BASE_URL;
            if (!baseUrl.endsWith('/')) {
                baseUrl += '/';
            }
            return `${baseUrl}images/${imageName}`;
        },
        // Agar rasm topilmasa (404), standart rasmni qo'yish
        handleImageError(event) {
            event.target.src = this.defaultImage;
        },
        getUser() {
            axios.get("/user/all").then(res => {
                if (res.data && res.data.data) {
                    this.hodimlar = res.data.data
                        .filter(element => ["Loborant", "Shifokor", "Hamshira"].includes(element.role))
                        .map(element => ({
                            user_id: element.id,
                            user_name: element.user_name,
                            image: element.image,
                            reyting: 0,
                            comment: ""
                        }));
                }
            });
        },
        setRating(model, val) {
            this.$set(model, 'reyting', val);
        },
        sendReyting(el, index) {
            let datas = {
                user_id: el.user_id,
                reyting: el.reyting || 0,
                comment: el.comment || "Izoh mavjud emas"
            }
            if (!datas.reyting) {
                this.$bvToast.toast(`Avval baho tanlang`, {
                    title: "Ogohlantirish",
                    variant: "warning",
                    autoHideDelay: 2500
                });
                return;
            }

            axios.post("/user/create_reyting", datas)
                .then(() => {
                    this.$bvToast.toast(`Fikringiz qabul qilindi!`, {
                        title: "Rahmat",
                        variant: "success",
                        autoHideDelay: 2000
                    });

                    el.reyting = 0;
                    el.comment = "";
                })
                .catch(() => {
                    this.$bvToast.toast(`Yuborishda xatolik bo'ldi`, {
                        title: "Xatolik",
                        variant: "danger",
                        autoHideDelay: 3000
                    });
                });
        }
    },
    mounted() {
        this.getUser();
    }
}
</script>

<style scoped lang="scss">
.wrap {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    background-color: #f0f2f5;
    padding: 20px;
}

.wrap_item {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 25px; /* Kartalar orasidagi masofa */
    padding-bottom: 50px;
}

.card {
    background: #fff;
    width: 290px; /* Karta enini biroz kattalashtirdim */
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 0.2s;
    border: 1px solid #e1e4e8;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    }
}

/* --- RASM UZUN QILIB SOZLANDI --- */
.image-box {
    width: 100%;
    height: 320px; /* MANA SHU YERDA BALANDLIK OSHIRILDI (Uzun bo'ladi) */
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 12px;
    background-color: #f8f9fa;
    border: 1px solid #eee;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover; /* Rasmni to'liq qoplaydi, bo'sh joy qolmaydi */
        object-position: top center; /* Rasmning eng tepasi (bosh qismi) ko'rinadi */
    }
}

.user-name {
    font-size: 18px;
    font-weight: 700;
    color: #2c3e50;
    text-align: center;
    margin: 5px 0 15px 0;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
}

.card_reyting {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-bottom: 15px;

    .icon {
        font-size: 36px;
        cursor: pointer;
        filter: grayscale(100%);
        opacity: 0.4;
        transition: all 0.2s;

        &:hover {
            opacity: 1;
            filter: grayscale(0%);
            transform: scale(1.1);
        }
    }
    
    .icon.selected {
        filter: grayscale(0%);
        opacity: 1;
        transform: scale(1.3);
    }
}

.text_input {
    width: 100%;
    height: 60px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    padding: 10px;
    font-size: 14px;
    resize: none;
    margin-bottom: 10px;
    outline: none;
    background-color: #fafafa;
    
    &:focus {
        border-color: #007bff;
        background-color: #fff;
    }
}

.btn {
    width: 100%;
    height: 40px;
    border-radius: 6px;
    background: #007bff;
    color: #fff;
    border: none;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background: #0056b3;
    }
}
</style>
